import type { ReactElement } from "react";
// eslint-disable-next-line no-duplicate-imports
import { useEffect, useState } from "react";
import { NavigationMVP } from "./NavigationMVP";
import { Button } from "../ui/button";
import { useQuery } from "@tanstack/react-query";
// import type { URLOpenListenerEvent } from "@capacitor/app";
// import { App } from "@capacitor/app";
import type { NotificationHistory } from "../../api/api";
// eslint-disable-next-line no-duplicate-imports
import { getNotificationsHistory } from "../../api/api";
import { useOs } from "@mantine/hooks";
import { BrokenNetworkConnectionIcon } from "@/components/icons/brokenNetworkConnection";
import { useOnlineStatusContext } from "@/context/OnlineStatusContext";

export const AppHeader = (): ReactElement => {

	const { data: notificationsHistory } = useQuery<NotificationHistory>({
		queryKey: ["notificationsHistory"],
		queryFn: getNotificationsHistory,
	});

	const { isOnline } = useOnlineStatusContext();
	const os = useOs();
	const [installPrompt, setInstallPrompt] = useState<Event | null>(null);

	useEffect(() => {
		window.addEventListener("beforeinstallprompt", (event) => {
			event.preventDefault();
			setInstallPrompt(event);
		});

		return (): void => {
			window.removeEventListener("beforeinstallprompt", (event) => {
				event.preventDefault();
				setInstallPrompt(event);
			});
		};
	}, []);

	const disableInAppInstallPrompt = (): void => {
		setInstallPrompt(null);
	};

	const installPWA = async (): Promise<void> => {
		console.log("Zainstaluj");

		if (installPrompt === null) {
			return;
		}
		try {

			const result = await installPrompt.prompt();
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			console.log(`Install prompt was: ${result.outcome}`);
			disableInAppInstallPrompt();
		} catch (error) {
			console.error("Error installing PWA:", error);
		}
	};

	const isDesktop = os === "windows" || os === "macos" || os === "linux";

	return (
		<>
			<header className="sticky top-0 flex lg:justify-center items-center h-[88px] p-6 pl-3 pt-safe-offset-6 gap-4 bg-white z-20">
				<NavigationMVP counterBadge={notificationsHistory?.counterBadge} />
				{!isOnline && <BrokenNetworkConnectionIcon className="" />}
			</header>

			{isDesktop && installPrompt !== null && (
				<div className="bg-seconadaryBackground w-full text-sm text-fontseconadry">
					<div className="flex justify-between items-center max-w-[890px] mx-auto p-3">
						<h4 className="font-bold">
							Zainstaluj aplikację Akademia LTCA na swoim komputerze
						</h4>
						<Button
							className="border-[1px] border-slate-200 bg-gradient-to-r from-[#0059FF] to-[#20314F] text-white"
							variant="ghost"
							onClick={installPWA}
						>
							Instalacja
						</Button>
					</div>
				</div>
			)}
		</>
	);
};
